export default (function (slots) {
  return slots.reduce(function (acc, currSlot) {
    return acc.concat(currSlot.prebid.map(function (currPrebid) {
      return {
        code: currSlot.id,
        mediaTypes: currPrebid.mediaTypes,
        bids: currPrebid.bids
      };
    }));
  }, []);
});